import React, { useEffect, useState } from "react";

export const slugifyHeading = (t) =>
  t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

/** Sticky right-side "On this page" nav with scroll-spy highlighting.
 * `items`: [{ id, label }] — ids must exist on the page's H2 elements. */
export default function LegalToc({ items, testid = "legal-toc" }) {
  const [active, setActive] = useState(items[0]?.id || "");

  useEffect(() => {
    if (!items.length) return undefined;
    const onScroll = () => {
      let current = items[0]?.id || "";
      for (const it of items) {
        const el = document.getElementById(it.id);
        if (el && el.getBoundingClientRect().top <= 150) current = it.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [items]);

  const go = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 110, behavior: "smooth" });
  };

  if (!items.length) return null;
  return (
    <nav className="md-legal-toc" aria-label="On this page" data-testid={testid}>
      <div className="md-legal-toc-head">On this page</div>
      <ul>
        {items.map((it) => (
          <li key={it.id}>
            <a
              href={`#${it.id}`}
              onClick={(e) => go(e, it.id)}
              className={active === it.id ? "active" : ""}
              data-testid={`${testid}-link-${it.id}`}
            >
              {it.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
